import { render, staticRenderFns } from "./LandingListaNacimiento.vue?vue&type=template&id=29a24a57"
import script from "./LandingListaNacimiento.vue?vue&type=script&lang=js"
export * from "./LandingListaNacimiento.vue?vue&type=script&lang=js"
import style0 from "./LandingListaNacimiento.vue?vue&type=style&index=0&id=29a24a57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports